import { redirect, resolvePath, To } from 'react-router-dom';

export default function redirectWithQuery(request: Request, to: To) {
  const url = new URL(request.url);
  url.pathname = resolvePath(to, url.pathname).pathname;
  return redirect(url.href);
}
